import { useState } from "react";
import { List } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

export const NavDrawer = ({ children }: { children: (props: { close: () => void }) => React.ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const close = () => setIsOpen(false);

  return (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-11 w-11 lg:h-11 lg:w-11"
          aria-label="Open navigation menu"
        >
          <List className="h-6 w-6" weight="bold" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] sm:w-[400px] transition-transform duration-300 bg-sidebar border-sidebar-border">
        {/* sr-only header wires Radix's aria-labelledby / aria-describedby
            without adding visible chrome. Without this, screen readers hear
            an unannounced dialog and Radix logs "Missing Description" on
            every mount. */}
        <SheetHeader className="sr-only">
          <SheetTitle>Navigation menu</SheetTitle>
          <SheetDescription>
            App navigation and quick actions for the current account.
          </SheetDescription>
        </SheetHeader>
        {children({ close })}
      </SheetContent>
    </Sheet>
  );
};
